import React, { useState, useEffect } from "react";
import ShortCoursesHeader from "../components/Courses/ShortCourses/ShortCoursesHeader";
import ShortCoursesCareerSkills from "../components/Courses/ShortCourses/ShortCoursesCareerSkills";
import ShortCoursesList from "../components/Courses/ShortCourses/ShortCoursesList";
import ShortCourseApplicationForm from "../components/Courses/ShortCourses/ShortCourseApplicationForm";
import FullScreenImage from "../components/Home/ShowcaseSection";
import Footer from "../components/sub-comp/MainFooter";
import Navbar from "../components/sub-comp/Navbar";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels";
import cmsApi from "../services/cmsApi";

const ShortCourses = () => {
  const [pageComponents, setPageComponents] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Only fetch on client side to avoid hydration issues
    if (typeof window === 'undefined') return;

    const fetchPageData = async () => {
      try {
        setLoading(true);
        
        // Fetch all page components for Short Course page
        const result = await cmsApi.getPageComponents('short-course');
        
        if (result.success && result.components) {
          // Filter to only active components and organize by componentName
          const componentsMap = {};
          result.components
            .filter(comp => comp.isActive !== false) // Only show active components
            .forEach(comp => {
              componentsMap[comp.componentName] = comp;
            });
          setPageComponents(componentsMap);
        } else {
          console.warn('No page components found, using defaults');
        }
      } catch (error) {
        console.error('Error fetching Short Course page data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPageData();
  }, []);

  // Show loading state (optional - you can remove this if you want to show default content immediately)
  if (loading && typeof window !== 'undefined') {
    return (
      <div>
        <Navbar />
        <div className="mid-desktop-page">
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-4 border-custom-pink border-t-transparent mx-auto mb-4"></div>
            <p className="text-gray-600">Loading Short Courses page...</p>
          </div>
        </div>
        </div>
        <Footer />
        <FloatingSocialPanels />
      </div>
    );
  }

  // Always render components - they have default content if CMS data is missing
  const headerComponent = pageComponents.header;
  const careerSkillsComponent = pageComponents['career-skills'];

  return (
    <div>
      <Navbar />
      <div className="mid-desktop-page">
      {/* Hero Section - Always render with defaults if no CMS data */}
      <ShortCoursesHeader componentData={headerComponent} />
      {/* Career Skills Section - Always render with defaults if no CMS data */}
      <ShortCoursesCareerSkills componentData={careerSkillsComponent} />
      {/* Subjects List Section */}
      <ShortCoursesList />
      {/* Application Form (open to everyone — no admission requirements) */}
      <ShortCourseApplicationForm />
      <FullScreenImage />
      </div>
      <Footer />
      <FloatingSocialPanels />
    </div>
  );
};

export default ShortCourses;
